import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import LoginPage from './components/LoginPage';
import AdminApp from './components/AdminApp';
import ClientApp from './components/ClientApp';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return isAuthenticated ? children : <Navigate to="/admin/login" replace />;
};

// Admin Login Page Wrapper Component
const AdminLoginPageWrapper = () => {
  return <LoginPage />;
};


// Main App with Auth Provider
const App = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Client routes - now default */}
          <Route path="/*" element={<ClientApp />} />
          
          {/* Admin routes */}
          <Route path="/admin/login" element={<AdminLoginPageWrapper />} />
          <Route 
            path="/admin/*" 
            element={
              <ProtectedRoute>
                <AdminApp />
              </ProtectedRoute>
            } 
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;